import { generatePath, useParams } from 'react-router-dom';

// by module path, not through the `router/components` barrel: that barrel
// also loads `Breadcrumbs`, and with it the whole `src/context` tree.
import Navigate from '../../../../router/components/Navigate';

/**
 * `/organizations/:organizationId/users/:userId` — the old second mount of the
 * client profile. One resource, one URL: everything that addressed it lands on
 * the canonical `/clients/:userId`, which is the only one with a breadcrumb
 * trail.
 */
export const LegacyClientProfileRedirect = () => {
  const { organizationId, userId } = useParams();

  return (
    <Navigate
      to={
        generatePath('/organizations/:organizationId/clients/:userId', {
          organizationId: organizationId ?? null,
          userId: userId ?? null,
        }) as '/organizations/:organizationId/clients/:userId'
      }
      replace
    />
  );
};
